<script setup lang="ts">
  import { announce } from '@/utils/a11yAlert'
  const { t } = useI18n()

  onMounted(() => {
    announce(t('loading'))
  })

  onUnmounted(() => {
    announce(t('loaded'))
  })
</script>

<template>
  <NuxtImg
    src="/plane.svg"
    alt=""
    class="size-32 animate-spin md:size-54 lg:size-80"
    aria-hidden="true"
  />
</template>
